import { memo } from 'react';
import PropTypes from 'prop-types';
import { css } from '@emotion/react';
import { Tooltip } from '@hotjar/webapp/components/Tooltip';
import cursorBlock from '@hotjar/shared-assets/icons/cursor-block.ico';
import { hoverEffect } from '../hoverEffect';

const RelevantActionBtn = ({ onClick, tooltip, disabled, className, children }) => {
  const button = (
    <button
      type="button"
      aria-label={tooltip}
      onClick={disabled ? () => {} : () => onClick()}
      disabled={disabled}
      css={css`
        background: transparent;
        border: 0;
        outline: none;
        width: 48px;
        height: 48px;
        padding: 0;

        ${hoverEffect}

        &[disabled] {
          cursor: url(${cursorBlock}), default;
          opacity: 0.25;
        }
      `}
      className={className}
    >
      {children}
    </button>
  );
  if (tooltip) {
    return (
      <Tooltip content={tooltip}>
        <span>{button}</span>
      </Tooltip>
    );
  }
  return button;
};

// FIXME: Add the missing default props or migrate to TypeScript.
/* eslint-disable react/require-default-props */
RelevantActionBtn.propTypes = {
  disabled: PropTypes.bool,
  onClick: PropTypes.func.isRequired,
  tooltip: PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
};

export const RelevantActionButton = memo(RelevantActionBtn);
